import "./Footer.css";

import {
  FaInstagram,
  FaWhatsapp,
  FaMapMarkerAlt,
} from "react-icons/fa";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">

      <div className="footer-container">

        {/* MARCA */}

        <div className="footer-brand">
          <h2>
            YANNA A&amp;P
            <span>CONSTRUCTIONS</span>
          </h2>

          <p>
            Espacios diseñados para ofrecer confort,
            elegancia y calidad en San Cristóbal.
          </p>
        </div>

        {/* NAVEGACIÓN */}

        <div className="footer-column">
          <span className="footer-title">NAVEGACIÓN</span>

          <a href="#nosotros">Nosotros</a>
          <a href="#proyecto">Proyecto</a>
          <a href="#apartamentos">Apartamentos</a>
          <a href="#galeria">Galería</a>
          <a href="#amenidades">Amenidades</a>
        </div>

        {/* CONTACTO */}

        <div className="footer-column">
          <span className="footer-title">CONTACTO</span>

          <a href="#contacto">
            <FaMapMarkerAlt />
            San Cristóbal, República Dominicana
          </a>

          <a href="#contacto">
            <FaWhatsapp />
            Contáctanos
          </a>

          <a
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
            Instagram
          </a>
        </div>

      </div>

      {/* PARTE INFERIOR */}

      <div className="footer-bottom">

        <p>
          © {currentYear} YANNA A&amp;P CONSTRUCTIONS.
          Todos los derechos reservados.
        </p>

        <p className="footer-developer">
          Diseñado y desarrollado por{" "}
          <strong>Sebastián Sánchez Aybar</strong>
        </p>

      </div>

    </footer>
  );
}

export default Footer;